import { cva } from "class-variance-authority";
import { Badge, cn } from "web-design-system";
import { SubmittedOrderType } from "creso-core/types";

const variants = cva("!text-xxs w-fit", {
  variants: {
    type: {
      PURCHASE: "bg-tag-green text-tag-green-foreground",
      REDEMPTION: "bg-tag-violet text-tag-violet-foreground",
      SWITCH_OUT: "bg-tag-blue text-tag-blue-foreground",
      SWITCH_IN: "bg-tag-blue text-tag-blue-foreground",
      "SIP INSTALLMENT": "bg-tag-green text-tag-green-foreground",
      "SWP INSTALLMENT": "bg-tag-violet text-tag-violet-foreground",
      "STP INSTALLMENT": "bg-tag-blue text-tag-blue-foreground",
    },
  },
});

export function OrderTypeBadge({
  type,
  className,
}: {
  type: SubmittedOrderType;
  className?: string;
}) {
  if (!type) return null;
  return (
    <Badge variant="custom" className={cn(variants({ type }), className)}>
      {type}
    </Badge>
  );
}
